import React from "react";
import { Container, Row, Image, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
// import "swiper/css/pagination";

export const RecommendCars = () => {
  return (
    <>
      <Container fluid>
        <Container>
          <div className="pb-2 pt-5 webkit">
            <h2 className="text-black text-4xl font-extrabold">
              Recommended Car
            </h2>
          </div>
          <Row>
            <Swiper
              id="mm1"
              // install Swiper modules
              modules={[Navigation, A11y]}
              spaceBetween={50}
              slidesPerView={3}
              loop={true}
              navigation
              pagination={{ clickable: false }}
              // scrollbar={{ draggable: true }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
              breakpoints={{
                "@0.00": {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                "@0.75": {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                "@1.00": {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                "@1.50": {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
            >
              <SwiperSlide>
                <div className="boxRecCar">
                  <Image
                    className="w-9/12"
                    src={require("../../assets/corollaRec.png")}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="boxRecCar">
                  <Image
                    className="w-9/12"
                    src={require("../../assets/brvRec.png")}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="boxRecCar">
                  <Image
                    className="w-9/12"
                    src={require("../../assets/hiacRec.png")}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="boxRecCar">
                  <Image
                    className="w-9/12"
                    src={require("../../assets/corollaRec.png")}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="boxRecCar">
                  <Image
                    className="w-9/12"
                    src={require("../../assets/brvRec.png")}
                  />
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="boxRecCar">
                  <Image
                    className="w-9/12"
                    src={require("../../assets/hiacRec.png")}
                  />
                </div>
              </SwiperSlide>
            </Swiper>
          </Row>
        </Container>
      </Container>
    </>
  );
};
